import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import id from 'vuetify/es5/locale/id'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { id },
    current: 'id'
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#00c853',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#b71c1c'
      }
    }
  }
})
